// src/layout/Footer.js
import React from 'react';
import './Footer.css'; // You can style it using a separate CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Nimra Khan | All Rights Reserved</p>
      <p>Follow me on social media!</p>
    </footer>
  );
};

export default Footer;
